import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      const scrolledPastHero = window.scrollY > 600;
      // Hide when reaching the main offer section to avoid clutter
      const offerSection = document.getElementById('oferta');
      const reachedOffer = offerSection ? window.scrollY >= offerSection.offsetTop - 400 : false;
      setIsVisible(scrolledPastHero && !reachedOffer);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-266">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 w-full z-50 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] py-4 px-4" data-id="element-267">
          <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-268">
            <div className="hidden md:block" data-id="element-269">
              <p className="font-bold text-[#1B4332]" data-id="element-270">
                Pack Completo de Diabetes
              </p>
              <p className="text-sm text-gray-500" data-id="element-271">3 Guías + 14 Bonus</p>
            </div>
            <div className="flex items-center gap-4 ml-auto md:ml-0" data-id="element-272">
              <span className="font-bold text-xl text-[#1B4332] mr-2" data-id="element-273">
                $29.99
              </span>
              <CTAButton text="Comprar Ahora" size="lg" showIcon={false} className="py-2 px-6 text-base" data-id="element-274" />
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}